import { Injectable } from '@angular/core';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { ArticleManager } from '@article/manager/article.manager';
import { ProjectModel } from '@project/model/project.model';
import { AlertHelper } from '@shared/alert/alert.helper';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { UndoRedoUtils } from '@shared/undo/undo-redo-utils';
import { UndoRedoHelper } from '@shared/undo/undo-redo.helper';
import { BlockingZoneArticleManager } from './blocking-zone-article-manager';
import { InsertArticleUtils } from '../util/insert-article-utils';
import { InsertArticleService } from '../service/insert-article.service';
import { SelectionModelService } from '../service/selection-model.service';
import { ApplicationRefreshService } from '@services/application-refresh.service';
import { DetachArticleUsageService } from '@project/service/detach-article-usage.service';

@Injectable({ providedIn: 'root' })
export class BlockingZoneArticleManagerFactory {
  constructor(
    private _insertArticleUtils: InsertArticleUtils,
    private _projectModel: ProjectModel,
    private _undoRedoHelper: UndoRedoHelper,
    private _alertHelper: AlertHelper,
    private _undoRedoUtils: UndoRedoUtils,
    private _selectionModelService: SelectionModelService,
    private _articleManager: ArticleManager,
    private _localeResourceManager: LocaleResourceManager,
    private _componentUtils: ContainerService,
    private _insertArticleService: InsertArticleService,
    private _applicationRefreshService: ApplicationRefreshService,
    private _detachArticleUsageService: DetachArticleUsageService
  ) {}

  public getNewInstance(): BlockingZoneArticleManager {
    return new BlockingZoneArticleManager(
      this._projectModel,
      this._undoRedoHelper,
      this._alertHelper,
      this._undoRedoUtils,
      this._insertArticleUtils,
      this._selectionModelService,
      this._articleManager,
      this._localeResourceManager,
      this._componentUtils,
      this._insertArticleService,
      this._applicationRefreshService,
      this._detachArticleUsageService
    );
  }
}
